import { render, staticRenderFns } from "./AllocateModules.vue?vue&type=template&id=ad1de1de&"
import script from "./AllocateModules.vue?vue&type=script&lang=js&"
export * from "./AllocateModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports